import React, { useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import { useLocation } from "react-router-dom";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import icon_img from "../../images/logo.png";
import { fontSize } from "../../styles";
import { fetchImageByName } from "../../utils/utility";
import { userResetPassword } from "../../service/logic";

const useStyles = makeStyles((theme) => ({
  bgContainer: {
    position: "fixed",
    width: "100vw",
    height: "100vh",
    overflow: "hidden",
    zIndex: -2,
  },
  backgroundCanvas: {
    position: "fixed",
    height: "100vh",
    width: "100vw",
    overflow: "hidden",
    zIndex: -2,
  },
  backgroundGreyCanvas: {
    position: "fixed",
    height: "100vh",
    width: "100vw",
    backgroundColor: "#c8c8c8",
    overflow: "hidden",
    zIndex: -3,
  },
  logo: {
    width: "60%",
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
    marginTop: 50,
    marginBottom: 50,
  },
  paper: {
    height: "100vh",
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    padding: 50,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 1,
  },
  bgClinic: {
    width: "66%",
    position: "absolute",
    marginLeft: "50%",
    marginTop: "10%",
  },
  form: {
    width: "90%",
    color: "#1D3557",
  },
  inputfield: {
    color: "#1D3557",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: `0px solid white`,
      },
      "&.Mui-focused fieldset": {
        border: `0px solid white`,
      },
    },
  },
  input: {
    color: "#1D3557",
    "&:hover": {
      color: "#457B9D",
    },
  },
  placeholderColor: {
    "&::placeholder": {
      color: "black",
      fontWeight: "bold",
    },
  },
  buttonContainer: {
    textAlign: "center",
    marginBottom: 20,
  },
  submit: {
    paddingLeft: 75,
    paddingRight: 75,
    backgroundColor: "#1D3557",
    borderRadius: 16,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    fontSize: fontSize.h4,
    "&:hover": {
      backgroundColor: "#457B9D",
    },
  },
  errorStyle: {
    color: "red",
    marginBottom: 10,
  },
}));

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function LoginScreen() {
  const query = useQuery();
  const token = query.get("token");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const validatePassword = () => {
    if (!password.length) {
      setErrorMessage("Empty password");

      return false;
    }

    if (password !== confirmPassword) {
      setErrorMessage("Password not match");

      return false;
    }

    return true;
  };

  const onResetPassword = async (event) => {
    event.preventDefault();

    if (validatePassword()) {
      await userResetPassword(token, password);
    }
  };

  const classes = useStyles();

  /** @type {HTMLCanvasElement} */
  const canvasRef = React.useRef(null);
  React.useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas === null) return;
    /** @type {CanvasRenderingContext2D}*/
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#457B9D";
    ctx.rotate(0.167 * Math.PI);
    ctx.fillRect(
      -ctx.canvas.width / 2,
      -ctx.canvas.height * 0.75,
      ctx.canvas.width,
      ctx.canvas.height
    );
    ctx.save();
    ctx.fillStyle = "#FFFFFF";
    ctx.rotate(-0.333 * Math.PI);
    ctx.fillRect(
      -ctx.canvas.width * 0.68,
      -ctx.canvas.width * 0.2,
      ctx.canvas.width,
      ctx.canvas.height * 2
    );
    ctx.save();
  }, [canvasRef]);

  return (
    <React.Fragment>
      <CssBaseline />
      <div className={classes.backgroundGreyCanvas} />
      <div className={classes.bgContainer}>
        <img
          className={classes.bgClinic}
          src={fetchImageByName("stageBackground")}
          alt={"clinic"}
        />
      </div>
      <canvas
        className={classes.backgroundCanvas}
        ref={canvasRef}
        width={window.innerWidth}
        height={window.innerHeight}
      />
      <div className={classes.paper}>
        <img className={classes.logo} src={icon_img} alt={"Virtual Patient"} />
        <form className={classes.form} noValidate>
          <Typography variant="h1" style={{ color: "black" }}>
            Reset Your Password
          </Typography>
          <Typography variant="h3" style={{ marginTop: 20 }}>
            Please enter and confirm your new password below to access your
            account
          </Typography>
          <TextField
            className={classes.inputfield}
            margin="normal"
            fullWidth
            name="password"
            placeholder="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={(event) => {
              setPassword(event.target.value);
            }}
            InputProps={{
              className: classes.input,
              classes: { input: classes.placeholderColor },
            }}
          />
          <TextField
            className={classes.inputfield}
            margin="normal"
            fullWidth
            name="password"
            placeholder="Confirm Password"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={(event) => {
              setConfirmPassword(event.target.value);
            }}
            InputProps={{
              className: classes.input,
              classes: { input: classes.placeholderColor },
            }}
          />
          <Typography className={classes.errorStyle}>{errorMessage}</Typography>
          <div className={classes.buttonContainer}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={(e) => {
                onResetPassword(e);
              }}
              style={{ textTransform: "none " }}
            >
              Reset Password
            </Button>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
}
